export const HEATMAP_DIAG_RASTER_SCREEN_INDEXES = {
  CONFIG: 0,
  IN_PROGRESS: 1,
  SUCCESS: 2,
  DUPLICATE: 3,
  WARNING: 4,
  ERROR: 5
};

export const POLARIZATION_SELECTIONS = {
  vertical: {
    title: 'Vertical',
    name: 'vpoldl',
    selected: true
  },
  horizontal: {
    title: 'Horizontal',
    name: 'hpoldl',
    selected: false
  },
  both: {
    title: 'Both',
    name: 'both',
    selected: false
  }
};

export const SAMPLE_ERROR_STATUS_DATA = {
  instanceId: 'RSTR-7eb8c80f-bfa9-445c-9f9b-fb1beccc94ae',
  runtimeStatus: 'Completed',
  input: {
    rasterId: 'RSTR-7eb8c80f-bfa9-445c-9f9b-fb1beccc94ae',
    deviceId: '89000200103210900084',
    devices: [
      {
        deviceId: '89000200103210900084',
        productType: 'donor'
      },
      {
        deviceId: '89000210103210600016',
        productType: 'service'
      }
    ],
    isVersionSupported: true,
    configuration: {
      polarization: 'HPolDL',
      algorithm: 'DEBUG'
    },
    metadata: {
      source: 'ibms',
      user: {
        userId: 'auth0|5fc6d3ff24597f006fdc57e4',
        name: 'nchen@pivotalcommware.com'
      },
      type: 'debug'
    }
  },
  createdTime: '2022-08-21T21:00:32Z',
  customStatus: {
    status: 'error',
    message: 'Unable to get gains for devices 89000200103210900084, 89000210103210600016',
    status_info: {
      rasterId: 'RSTR-7eb8c80f-bfa9-445c-9f9b-fb1beccc94ae'
    }
  }
};
